import { SchemaFieldType } from '@carto/api-client'
import { AttributeType } from '../types'

export function mapSchemaTypeToAttributeType(type: SchemaFieldType): AttributeType | undefined {
  if (type === 'timestamp') {
    return AttributeType.Timestamp
  }
  if (type === 'string' || type === 'boolean') {
    return AttributeType.String
  }
  if (type === 'number') {
    return AttributeType.Number
  }
  return undefined
}
